import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiService } from '../../../services/api.service';
import { ApiResponse } from '../../../shared/types';
import { OrdersService } from '../../../orders/services/orders.service';
import {
  ConfirmWayPurchaseRequest,
  ConfirmShopPurchaseRequest,
  WayPurchaseLookupRequest,
  WayPurchaseLookupData,
} from '../models/way-purchase.models';

@Injectable({ providedIn: 'root' })
export class WayPurchaseApiService {
  constructor(
    private readonly apiService: ApiService,
    private readonly ordersService: OrdersService
  ) {}

  confirmWayPurchase(payload: ConfirmWayPurchaseRequest): Observable<any> {
    return this.apiService.post('order/confirm-way', payload).pipe(
      tap(() => this.ordersService.refreshOrders({ resetPage: true }))
    );
  }

  confirmShopPurchase(payload: ConfirmShopPurchaseRequest): Observable<any> {
    return this.apiService.post('order/confirm-shop-purchase', payload).pipe(
      tap(() => this.ordersService.refreshOrders({ resetPage: true }))
    );
  }

  lookupWayPurchases(payload: WayPurchaseLookupRequest): Observable<ApiResponse<WayPurchaseLookupData>> {
    return this.apiService.post<WayPurchaseLookupData>('order/way-purchase-lookup', payload);
  }

  /**
   * Promote an LPR row from way-purchase-unredeemable to create-order-request so hydration
   * does not remap the staff handoff UI back to the Way terminal event.
   */
  promoteLprEntryToCreateOrderRequest(
    lprEntryId: string,
    fields: Record<string, any> = {}
  ): Observable<any> {
    const updatePayload: Record<string, any> = {
      ...fields,
      licence_plate_id: lprEntryId,
      // Always force the handoff event last so callers cannot override it via fields.
      event: 'create-order-request',
    };
    return this.apiService.put(`order/lpr-entries/${lprEntryId}`, updatePayload);
  }
}
